import SignIn from '$modules/onboarding/module-components/sign-in';
const SignInMobile = () => {
  return <SignIn data-sentry-element="SignIn" data-sentry-component="SignInMobile" data-sentry-source-file="signIn.mobile.tsx" />;
};
export default SignInMobile;